<template>
  <div class="w-100 m-0 logout">
    <div
      class="d-flex"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <div>
        <img
          v-if="data.avatar"
          :src="data.avatar"
          alt="icon"
          class="profile-icon-2 rounded-circle"
        >
        <img
          v-if="!data.avatar"
          src="@/assets/icon/guest.png"
          alt="icon"
          class="profile-icon-2 rounded-circle"
        >
      </div>
      <div class="pl-3 align-items-end text-truncate">
        <div class="font-weight-bold text-size-one">
          {{ data.fullname }}
        </div>
        <div class="text-size-two text-secondary">
          {{ data.role.name }}
        </div>
      </div>
    </div>
    <div class="dropdown-menu">
      <router-link
        v-if="permission.permissions.includes('browse') && permission.permissions.includes('read')"
        class="px-3 dropdown-item"
        tag="a"
        to="user-profile"
      >
        <div class="row m-0 p-0 pb-2 border-bottom">
          <div class="col-3 p-0">
            <img
              v-if="data.avatar"
              :src="data.avatar"
              alt="icon"
              class="profile-icon-2 rounded-circle"
            >
            <img
              v-if="!data.avatar"
              src="@/assets/icon/guest.png"
              alt="icon"
              class="profile-icon-2 rounded-circle"
            >
          </div>
          <div class="col-9 p-0">
            <div class="p-0 m-0">
              <strong>{{ data.fullname }}</strong>
            </div>
            <div class="text-email p-0 m-0">
              <strong>{{ data.email }}</strong>
            </div>
          </div>
        </div>
      </router-link>
      <a
        v-if="permission.permissions.includes('browse') && !permission.permissions.includes('read')"
        class="px-3 dropdown-item"
      >
        <div class="row m-0 p-0 pb-2 border-bottom">
          <div class="col-3 p-0">
            <img
              v-if="data.avatar"
              :src="data.avatar"
              alt="icon"
              class="profile-icon-2 rounded-circle"
            >
            <img
              v-if="!data.avatar"
              src="@/assets/icon/guest.png"
              alt="icon"
              class="profile-icon-2 rounded-circle"
            >
          </div>
          <div class="col-9 p-0">
            <div class="p-0 m-0">
              <strong>{{ data.fullname }}</strong>
            </div>
            <div class="text-email p-0 m-0">
              <strong>{{ data.email }}</strong>
            </div>
          </div>
        </div>
      </a>
      <a class="px-3 dropdown-item">
        <div class="m-0 p-0 pb-2 text-center">
          <div
            @click="logout()"
          >
            <div class="p-0 m-0 pt-1">
              <strong class="text-logout">Logout</strong>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logout',

  data () {
    return {
      data: {
        role: {
          name: ''
        }
      },
      permission: {
        permissions: []
      }
    }
  },

  created () {
    this.getPermission()
    this.setData()
  },

  methods: {
    getPermission () {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      const index = dataLoc.role.permissions.findIndex(element => element.category === 'profile')
      this.permission = dataLoc.role.permissions[index]
    },
    setData () {
      this.data = JSON.parse(localStorage.getItem('profile'))
    },
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style scoped>

.profile-icon {
  width: 26px;
  height: 26px;
  padding-top: 2px;
  object-fit: cover;
}
.profile-icon-2{
  width: 26px;
  height: 26px;
  padding-top: 1px;
  object-fit: cover;
}
.dropdown-item {
  font-size: 12px;
}
.dropdown-menu {
  width: 200px !important;
}
.text-email {
  font-size: 8px;
  color: #0091FF;
}
.text-logout {
  font-size: 13px;
  color: #E02020;
}
.border-bottom {
  border-bottom: 2px solid #DEDEDE;
}
.logout {
  cursor: pointer;
}
.text-size-one {
  font-size: 12px;
}
.text-size-two {
  font-size: 10px;
}
</style>
